/* eslint-disable react/prop-types */
import React from "react";
import DailyPulseModule from "./dailyPulse";
import { Provider } from "react-redux";
import { createReduxStore } from "./redux/store";

const DailyPulse = (props) => {
  let {
    organizationId,
    locationId,
    objectId,
    regionId,
    params: { calendarStartDate, calendarEndDate, showChart },
    notifications
  } = props;

  let params = {
    organizationId,
    locationId,
    objectId,
    regionId,
    calendarEndDate,
    calendarStartDate
  };
  return (
    <Provider store={createReduxStore()}>
      <DailyPulseModule params={params} notifications={notifications} showChart={showChart} />
    </Provider>
  );
};

export default DailyPulse;
